import { cn } from '@/lib/utils';

function Swatch({ className }: { className?: string }) {
  return (
    <i
      aria-hidden
      className={cn('inline-block h-2.5 w-4 border border-edge', className)}
    />
  );
}

export function RaceLegend() {
  return (
    <div className="flex flex-wrap gap-x-5 gap-y-2 px-3 pb-3 font-mono text-[11px] text-muted-foreground">
      <span className="inline-flex items-center gap-2">
        <Swatch className="bg-muted-foreground/25" />
        AI generation, identical in both
      </span>
      <span className="inline-flex items-center gap-2">
        <Swatch className="bg-[repeating-linear-gradient(45deg,var(--color-muted-foreground),var(--color-muted-foreground)_4px,transparent_4px,transparent_8px)]" />
        our overhead, the only thing that shrank
      </span>
    </div>
  );
}
